import {
  startOfDay,
  startOfWeek,
  addDays,
  differenceInCalendarDays,
  format,
  isValid,
  parseISO
} from "date-fns";
import { ptBR } from "date-fns/locale";
import { OutputItem } from "../MapInfo/utils";

export const STATUS_SEMAFORO = 
[
  {
      status: 1,
      color: '#006400',
  },
    {
      status: 2,
      color: '#FFA500',
  },
    {
      status: 3,
      color: '#FF0000',
  },
]

type DatesProps = {
  days: string[];
  daysWithMonth: string[];
}

export type Datas = {
    dataProgramada?: string;
    dataPrint?: string;
    color?: string;
};


export function getHoje() {
  return {
    days: [formatarDia(startOfDay(new Date()))],
    daysWithMonth: [formatarDiaCapitalizado(startOfDay(new Date()))],
  }
}

export function getSemana() {
  const today = new Date();
  const start = startOfWeek(today, { weekStartsOn: 0 });

  const dates =  Array.from({ length: 7 }, (_, i) =>
    startOfDay(addDays(start, i))
  );

  return {
    days: dates.map(formatarDia),
    daysWithMonth: dates.map(formatarDiaCapitalizado),
  }
}



export function getPeriodoCustomArray(
  start: Date,
  end: Date
) {
  const diff = differenceInCalendarDays(end, start);

  if (diff < 0) {
    throw new Error("Data final menor que inicial");
  }

  if (diff > 14) {
    throw new Error("O período máximo permitido é de 15 dias");
  }

  const dates = Array.from({ length: diff + 1 }, (_, i) =>
    startOfDay(addDays(start, i))
  );

  return {
    days: dates.map(formatarDia),
    daysWithMonth: dates.map(formatarDiaCapitalizado),
  }
}

export function validarIntervalo(start: Date, end: Date) {
  const diff = differenceInCalendarDays(end, start);

  return diff <= 14;
}

export function formatarDia(date: Date): string {
   if (!isValid(date)) return "";
  return format(date, "yyyy-MM-dd");
}

export function formatarDiaCapitalizado(date: any): string {
  if (!isValid(date)) return "";
  const dia = format(date, "dd 'de'", { locale: ptBR });
  const mes = format(date, "MMMM", { locale: ptBR });

  return `${dia} ${mes.charAt(0).toUpperCase()}${mes.slice(1)}`;
}

export function formatarDiaCapitalizadoUTC(dateString: any): string {

  if (!dateString) return "";

  const date = parseISO(dateString.toString().replace("Z", ""));
  if (!isValid(date)) return "";

  const dia = format(date, "dd 'de'", { locale: ptBR });
  const mes = format(date, "MMMM", { locale: ptBR });


  return `${dia} ${mes.charAt(0).toUpperCase()}${mes.slice(1)}`;

}

export const COLORS = [
    "#C0DD9A",
    "#EB755B",
    "#9FCCEF",
    "#FEF9B0",
    "#FFA7EF",
    "#FFCC5C",
    "#9DDE48",
    "#3187DA",
    "#DA455C",
    "#A59500",
    "#E643C8",
    "#B7C460",
    "#1FB3EC",
    "#676C77",
    "#D0D3DA",
    "#398C51",
]

export function getDatedMount(
  dataValue: string | null | undefined,
  setCustom: (args: boolean) => void,
  setRange: (args: any) => void,
  setDatas: (args: any) => void
) {
  if (!dataValue) {
    setCustom(false);
    setRange(null);
    setDatas([]);
    return [];
  }

  let dates: DatesProps | null = null;
   switch(dataValue) {
      case 'hoje':
          dates = getHoje();
          setCustom(false);
          break;
      case 'essa-semana':
          dates = getSemana();
          setCustom(false);
          break;
      case 'personalizado':
          setCustom(true);
          setRange(null);
          setDatas([]);
          return [];
  }

  if (!dates) return [];
  const newDatas: Datas[] = [];
  if (dates?.days?.length > 0) {
      dates?.days?.forEach((_, index: number) => {
          newDatas.push({
              dataPrint: dates?.daysWithMonth[index],
              dataProgramada: dates?.days[index],
              color: COLORS[index]
          })
      });
      setRange(null);
      setDatas(newDatas);

      return newDatas;
  }

  return newDatas.map((item) => ({
    dataProgramada: item?.dataProgramada,
    color: item?.color,
    dataPrint: item?.dataPrint
  }));
}

export function getSemanaArray() {
  const newDatas: Datas[] = [];
  const dates = getSemana();
   if (dates?.days?.length > 0) {
      dates?.days?.forEach((_, index: number) => {
          newDatas.push({
              dataPrint: dates?.daysWithMonth[index],
              dataProgramada: dates?.days[index],
              color: COLORS[index]
          })
      });

      return newDatas;
  } 
}

export function getDatedMountPersonalizada(
  dates: any,
  setDatas: (args: any) => void,
  setStartDate: (args: any) => void
) {
  setStartDate(dates?.[0] ?? null);

  if (!dates?.[0] || !dates?.[1]) {
    setDatas([]);
    return [];
  }

  try {
    const inicio: Date = dates?.[0]?.toDate();
    const fim: Date = dates?.[1]?.toDate();
    const dias = getPeriodoCustomArray(inicio, fim);
    const newDatas: Datas[] = [];
  
    if (dias.daysWithMonth.length > 0) {
        dias.daysWithMonth.forEach((_, index: number) => {
            newDatas.push({
                dataPrint: dias?.daysWithMonth[index],
                color: COLORS[index],
                dataProgramada: dias?.days[index]
            });
        });
    
      setDatas(newDatas);
  
      return newDatas;
    }

  } catch (error) {
    console.log(error);
  }
}

export function getStatus(status: string): string {
  switch (status) {
    case "A":
      return "ABERTA";
    case "F":
      return "FECHADA";
    default:
      return " - ";
  }
}

export function dateFormat(dateStr: string) {
  if (!dateStr) return "";
  const [year, month, day] = dateStr.split("-").map(Number);
  const newDate = new Date(year, month - 1, day); // LOCAL

  if (!isValid(newDate)) return "";

  return format(newDate, "dd/MM/yyyy");
}

export function dateFormatSimple(dateStr: string) {
  const newDate = new Date(dateStr);
  if (!isValid(newDate)) return "";
  
  return format(newDate, "dd/MM")
}

export const normalizar = (str: string) =>
  str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

export const extrairNumero = (str: string) => {
  const match = str.match(/\d+/);
  return match ? Number(match[0]) : null;
};

export const extrairTexto = (str: string) =>
  normalizar(str).replace(/\d+/g, "").trim();

export const montarTextoOS = (item: any) => {
        return normalizar(
            `
            ${item.numero}
            ${item.equipe}
            ${item.operacao}
            ${item.operacaoQuantidade} operacoes
            ${item.quantidadeTalhoes} talhoes
            ${dateFormat(item.dataAbertura)}
            `
        );
};

export type OsListFiltroTipo =
  | "os-sem-planos"
  | "os-com-planos"
  | "talhoes-sem-plano";

export function inferHomogeneousOsListTipo(
  items: any[]
): OsListFiltroTipo | null {
  if (!items?.length) return null;
  const allTalhaoSemPlano = items.every(
    (i) => i.possuiTalhaoSemPlanoOperacional === true
  );
  const allSemPlanoOp = items.every((i) => i.possuiPlanoOperacional === false);
  const allComPlanoOp = items.every((i) => i.possuiPlanoOperacional === true);
  if (allTalhaoSemPlano) return "talhoes-sem-plano";
  if (allSemPlanoOp) return "os-sem-planos";
  if (allComPlanoOp) return "os-com-planos";
  return null;
}

export function amountColorAndDate(datas: Datas[], datasInfoComplete: OutputItem[], priorityDateColorBackend: boolean = false) {
     const newDatasComplete = datas?.filter((item: Datas) => {
        return datasInfoComplete.some((s: any) => 
            (s.color === item.color && s?.dateComplete === item?.dataPrint)
            || (s.color !== item.color && s?.dateComplete === item?.dataPrint)
        );
    });

    if (!priorityDateColorBackend) {
        return newDatasComplete;
    }
    
    
    return newDatasComplete?.map((item: any) => {
      const newItem = datasInfoComplete.find((s: any) => 
          (s.color !== item.color && s?.dateComplete === item?.dataPrint));
      let newColor = "";

      if(newItem) {
          newColor = newItem.color
      } else {
        newColor = item.color
      }

      return {
          ...item,
          color: newColor
      }
  });
}
export type WindowExecutionData = {
  id: string;
  periodoDataInicio: string;
  periodoDataFim: string;
  periodoDataInicioRaw: string;
  periodoDataFimRaw: string;
  counter: number;
  color: string;
  operacao: string;
  operacaoClasse: string;
  operacaoId: string;
};

export const WINDOW_OVERLAP_COLOR = "#2C2F33";

export function normalizeOperacaoClasse(operacaoClasse?: string | null): string {
  return !operacaoClasse || operacaoClasse === " - " ? "SEM CLASSE" : operacaoClasse;
}

export function getWindowExecutionKey(
  periodoDataInicio: string,
  periodoDataFim: string,
  operacaoClasse?: string
) {
  const inicio = periodoDataInicio.slice(0, 10);
  const fim = periodoDataFim.slice(0, 10);
  return `${inicio}-${fim}-${normalizeOperacaoClasse(operacaoClasse)}`;
}

export function isPlanoPintavelJanela(plano: any): boolean {
  const status = plano?.StatusDescricao ?? plano?.status;

  if (typeof status === "string") {
    return status === "Planejada" || status === "ExecutadaParcialmente";
  }

  if (plano?.DataExecucao) return false;

  return true;
}

export function matchPlanoToWindow(plano: any, window: WindowExecutionData): boolean {
  return (
    plano?.PeriodoDataInicio?.slice(0, 10) === window.periodoDataInicioRaw &&
    plano?.PeriodoDataFim?.slice(0, 10) === window.periodoDataFimRaw &&
    normalizeOperacaoClasse(plano?.OperacaoClasse) === window.operacaoClasse
  );
}

export function getMatchedWindowsForPlanos(
  planos: any[],
  rangeWindows: WindowExecutionData[]
): WindowExecutionData[] {
  const matches = new Map<string, WindowExecutionData>();

  planos.forEach((plano) => {
    if (!isPlanoPintavelJanela(plano)) return;

    rangeWindows.forEach((window) => {
      if (matchPlanoToWindow(plano, window)) {
        matches.set(window.id, window);
      }
    });
  });

  return Array.from(matches.values());
}

export type PlanoOperacionalRaw = {
  DataProgramada?: string;
  PeriodoDataInicio?: string;
  PeriodoDataFim?: string;
  Operacao?: string;
  OperacaoClasse?: string;
  OperacaoId?: string;
};

export function amountColorAndDateWindowExecution(
  mapListInfo: any[] | undefined | null
): WindowExecutionData[] {
  const listedPlanos: PlanoOperacionalRaw[] = (mapListInfo ?? [])
    .flatMap((feature: any) => feature?.properties?.planosoperacionais ?? [])
    .filter(
      (plano: PlanoOperacionalRaw) => plano?.DataProgramada && plano?.PeriodoDataInicio && plano?.PeriodoDataFim
    );

  const periodMap = new Map<string, WindowExecutionData>();

  listedPlanos.forEach((plano) => {
    const inicio = plano.PeriodoDataInicio!.slice(0, 10);
    const fim = plano.PeriodoDataFim!.slice(0, 10);
    const operacao = plano.Operacao ?? "";
    const operacaoId = plano.OperacaoId ?? "";
    const operacaoClasse = normalizeOperacaoClasse(plano.OperacaoClasse);
    const key = getWindowExecutionKey(inicio, fim, operacaoClasse);

    const existing = periodMap.get(key);

    if (existing) {
      existing.counter += 1;
      return;
    }

    periodMap.set(key, {
      id: key,
      periodoDataInicio: dateFormat(inicio),
      periodoDataFim: dateFormat(fim),
      periodoDataInicioRaw: inicio,
      periodoDataFimRaw: fim,
      operacao,
      operacaoClasse,
      operacaoId,
      counter: 1,
      color: "",
    });
  });

  return Array.from(periodMap.values())
    .sort(
      (a, b) =>
        a.periodoDataInicioRaw.localeCompare(b.periodoDataInicioRaw) ||
        a.periodoDataFimRaw.localeCompare(b.periodoDataFimRaw) ||
        a.operacao.localeCompare(b.operacao)
    )
    .map((window, index) => ({
      ...window,
      color: COLORS[index % COLORS.length],
    }));
}

export function normalizeDataAbertura(dataAbertura?: string | null): string {
  if (!dataAbertura) return "";
  return dataAbertura.slice(0, 10);
}

export function matchDataAberturaComDatas(
  dataAbertura: string | undefined | null,
  datas: Datas[] | null | undefined
): boolean {
  if (!datas?.length) return true;

  const dataAberturaNorm = normalizeDataAbertura(dataAbertura);
  if (!dataAberturaNorm) return false;

  return datas.some(
    (d) => d.dataProgramada && d.dataProgramada === dataAberturaNorm
  );
}

export function formatDateBR(dateString: string) {
  if (!dateString) return "";
  const date = new Date(dateString);

  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();

  return `${day}/${month}/${year}`;
}